import { Helmet } from "react-helmet";

export function SEO({ title, description, canonical, type = "website" }) {
  const siteUrl = "https://algoostrategies.org";
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
    </Helmet>
  );
}
